import { Job } from '@/class/model/booking/Job'
import AbstractViewManage from '@/class/view/AbstractViewManage'

export default class CheckingWindowHP extends AbstractViewManage {
  constructor(view) {
    super(view)
  }
}
